import { createSlice } from '@reduxjs/toolkit';

const initialState = { autenticated: false };

const invitedSlice = createSlice({
  name: 'invitedSlice',
  initialState,
  reducers: {
    setAutenticated: (state, action) => {
      state.autenticated = action.payload;
    }
  }
});

export const { setAutenticated } = invitedSlice.actions;
export default invitedSlice.reducer;
